import { render, staticRenderFns } from "./CustomerContractDetails.vue?vue&type=template&id=7ddffaf6&"
import script from "./CustomerContractDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerContractDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports